import { render } from "./MovieTag.vue?vue&type=template&id=434a6665"
import script from "./MovieTag.vue?vue&type=script&lang=js"
export * from "./MovieTag.vue?vue&type=script&lang=js"

import "./MovieTag.vue?vue&type=style&index=0&id=434a6665&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__